import { render, staticRenderFns } from "./ProspectEchange.vue?vue&type=template&id=08fafd51"
import script from "./ProspectEchange.vue?vue&type=script&lang=ts"
export * from "./ProspectEchange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports